import { UPLOAD_STATES } from '~/lib/constants/upload-states'
import { isEmptyFile } from '~/lib/utils/upload-validation'

/**
 * Tally final per-file upload states into outcome counts.
 * @param {{state: string}[]} files
 * @returns {{doneCount: number, failedCount: number, oversizedCount: number}}
 */
export function summarizeUploadStates(files) {
  const list = Array.from(files ?? [])

  return {
    doneCount: list.filter((file) => file?.state === UPLOAD_STATES.DONE).length,
    failedCount: list.filter((file) => file?.state === UPLOAD_STATES.FAILED).length,
    oversizedCount: list.filter((file) => file?.state === UPLOAD_STATES.OVERSIZED).length,
  }
}

/**
 * GA4 params for the "upload_selection" event. No PII (no filenames).
 * @param {{files: (File[]|FileList), isIOS: boolean, isSafari: boolean, pickToChangeMs?: (number|null)}} input
 * @returns {object}
 */
export function buildUploadSelectionParams({ files, isIOS, isSafari, pickToChangeMs = null }) {
  const list = Array.from(files ?? [])

  return {
    file_count: list.length,
    total_bytes: list.reduce((sum, file) => sum + (file?.size ?? 0), 0),
    empty_count: list.filter(isEmptyFile).length,
    is_ios: Boolean(isIOS),
    is_safari: Boolean(isSafari),
    pick_to_change_ms: pickToChangeMs ?? null,
  }
}

/**
 * GA4 params for the "upload_outcome" event.
 * @param {{summary: {doneCount?: number, failedCount?: number, oversizedCount?: number}, isIOS: boolean}} input
 * @returns {object}
 */
export function buildUploadOutcomeParams({ summary, isIOS }) {
  return {
    done_count: summary?.doneCount ?? 0,
    failed_count: summary?.failedCount ?? 0,
    oversized_count: summary?.oversizedCount ?? 0,
    is_ios: Boolean(isIOS),
  }
}
